// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/save-the-date-necazubi-ausbildungsmesse/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const saveTheDateNecazubiAusbildungsmesseDE: PageEntry = {
  id: "post.save-the-date-necazubi-ausbildungsmesse",
  locale: "de",
  slug: "save-the-date-necazubi-ausbildungsmesse",
  seo: {
    title: "Save the date: NECAzubi – Ausbildungsmesse | Dietz GmbH",
    description: "Save the date: NECAzubi – Ausbildungsmesse",
  },
  type: "post",
  h1: "Save the date: NECAzubi – Ausbildungsmesse",
  blocks: [
    { kind: "heading", level: 2, text: "Save the date: NECAzubi – Ausbildungsmesse" },
    { kind: "paragraph", text: "Wir sind als Sponsor und natürlich auch als Aussteller bei der „ NECAzubi – Ausbildungsmesse“ vor Ort und freuen uns über Euer kommen!" },
    { kind: "paragraph", text: "Wann? Donnerstag, 14. März 2024 Wo? Frankenhalle Neustadt Wer? Alle Interessierten" },
    { kind: "image", src: "/images/live/insta-necazubi-2024.png", alt: "necazubi", width: 1080, height: 1080 }
  ],
};
